import { Button, ButtonProps } from "@chakra-ui/react";
import React, { useCallback } from "react";
import { useIntercom } from "react-use-intercom";
import { useUserContext } from "../../contexts/UserContext";
import { getRandomId } from "../../helper/GetRandomId";

export interface ContactSupportProps extends ButtonProps {
  supportPrompt: string; // prompt to pre-fill in support chat
}

export function ContactSupport({
  supportPrompt,
  ...props
}: ContactSupportProps) {
  const { userDetails } = useUserContext();
  const { showNewMessages, update } = useIntercom();

  const contactSupport = useCallback(() => {
    // set email to avoid the "which email should we contact you on?" prompt.
    update({
      userId: userDetails?.id ?? getRandomId(),
      email: userDetails?.email,
    });
    showNewMessages(supportPrompt);
  }, [
    supportPrompt,
    showNewMessages,
    update,
    userDetails?.email,
    userDetails?.id,
  ]);

  return (
    <Button onClick={contactSupport} {...props}>
      Request Support
    </Button>
  );
}
